import script from "./AddTempleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTempleModal.vue?vue&type=script&setup=true&lang=js"

import "./AddTempleModal.vue?vue&type=style&index=0&id=e6688a04&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6688a04"]])

export default __exports__